/**
 * Exibe o logo da empresa. Se nao houver logo, mostra um circulo com a inicial.
 */
export default function CompanyLogo({ url, name, size = 30 }) {
  if (url) {
    return <img src={url} alt={name || 'logo'} className="company-logo" style={{ width: size, height: size }} />;
  }
  const initial = (name || '?').trim().slice(0, 1).toUpperCase();
  return (
    <span className="company-logo fallback" style={{ width: size, height: size, fontSize: Math.round(size * 0.42) }}>
      {initial}
    </span>
  );
}
